import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import CreateInvestment2 from "./Forms/createInvestment2";
import { FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import { GoBriefcase } from "react-icons/go";
import { ReactComponent as RightArrow } from "../../../myfin_v2/assets/icons/rightArrowEcl.svg";
import { ReactComponent as ArrowRightIcon } from "../../../myfin_v2/assets/icons/arrowRight.svg";
import { ReactComponent as CalendarIcon } from "../../../myfin_v2/assets/icons/calender.svg";
const statusStyles = {
  Investment: { bg: "#E8FEFF", color: "#42778B", border: "#CAE6E6" },
  "Associate Company": { bg: "#FDF5E9", color: "#A7683E", border: "#EDE3D8" },
  Subsidiary: { bg: "#F0EBFD", color: "#564AC5", border: "#D4D1E3" },
  "Joint Venture": { bg: "#F6FDE7", color: "#778F41", border: "#DAEAAE" },
};

const dotStyles = {
  Investment: { outerBg: "#E8FEFF", outerBorder: "#CAE6E6", innerBg: "#42778B" },
  "Associate Company": { outerBg: "#FDF5E9", outerBorder: "#EDE3D8", innerBg: "#A7683E" },
  Subsidiary: { outerBg: "#F0EBFD", outerBorder: "#D4D1E3", innerBg: "#564AC5" },
  "Joint Venture": { outerBg: "#F6FDE7", outerBorder: "#DAEAAE", innerBg: "#778F41" },
};

const getStatusLabel = (status) => {
  if (!status) return "Investment";

  const normalized = status.trim().toLowerCase();

  if (normalized === "investment") return "Investment";
  if (normalized === "associate company" || normalized === "associate")
    return "Associate Company";
  if (normalized === "subsidiary") return "Subsidiary";
  if (normalized === "joint venture") return "Joint Venture";

  return "Investment";
};
const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

const InvestmentTimeline = ({ timelineData,  investmentID, sortOrder, onRefresh  }) => {
  const [timeline, setTimeline] = useState([]);
  const [currentStatus, setCurrentStatus] = useState("Investment");
  const [openEntry, setOpenEntry] = useState(null);
  const [entryData, setEntryData] = useState(null);
  const [loadingId, setLoadingId] = useState(null);
  const handleOpen = (entry) => {
  setEntryData({
    ...entry.initialData,

    previousShares: entry.sharesTo,
    previousOwnership: Number(entry.ownership),
  });

  setOpenEntry(entry);
};
useEffect(() => {
  if (!timelineData?.timeline) return;

  const sorted = [...timelineData.timeline].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );

  let prevShares = 0;

  const formatted = sorted.map((item, i) => {
    const purchased = Number(item.noOfSharesPurchased) || 0;
    const sold = Number(item.noOfSharesSold) || 0;
    const totalSharesOutstanding = Number(item.totalSharesOutstanding) || 0;

    let newShares;

    if (item.natureOfTransaction?.toLowerCase().includes("sale")) {
      newShares = prevShares - sold;
    } else {
      newShares = prevShares + purchased;
    }

    const entry = {
      id: item._id,
      investmentID: investmentID,
      initialData: item,
      date: formatDate(item.transactionDate),
      title: item.natureOfTransaction,
      tranch: `TRANCH ${i + 1}`,
      totalConsideration: item.totalConsideration,
      sharesFrom: i === 0 ? null : prevShares,
      sharesTo: newShares,
      ownership: totalSharesOutstanding
      ? ((newShares / totalSharesOutstanding) * 100).toFixed(2)
      : 0,
      status: item.natureOfRelationship || "Investment",
    };

    prevShares = newShares;
    return entry;
  });

  const finalTimeline =
    sortOrder === "desc" ? [...formatted].reverse() : formatted;

  setTimeline(finalTimeline);

 setCurrentStatus(
    finalTimeline.length
      ? getStatusLabel(finalTimeline[0].status)
      : "Investment"
  );

}, [timelineData, sortOrder]);

const handleBack = () => {
  setOpenEntry(null);
  setEntryData(null);
  if (onRefresh) onRefresh();
};

  return (
    <div style={{ position: "relative" }}>
    <div style={{ background: "#fff", padding: 32, borderRadius: 16 }}>
      <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 30,
        paddingBottom: 16,
        borderBottom: "1px solid #eaeeed",
        marginLeft: -32,  
        marginRight: -32,
        paddingLeft: 32,
        paddingRight: 32,
      }}
    >
        <h6 style={{ fontWeight: "400" , fontSize: "20px"}}>Investment Timeline</h6>

        <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: -10 }}>
          <span style={{ fontSize: "14px", color: "#66827A" }}>Current Status</span>
          <span
            style={{
              background: statusStyles[currentStatus]?.bg,
              color: statusStyles[currentStatus]?.color,
              border: `1px solid ${statusStyles[currentStatus]?.border}`,
              padding: "3px 16px",
              borderRadius: 20,
              fontWeight: 700,
              fontSize: "14px",
              letterSpacing: "1px",
            }}
          >
            {currentStatus.toUpperCase()}
          </span>
        </div>
      </div>

      <div style={{ position: "relative", display: "flex", flexDirection: "column", gap: 40 }}>
      <div style={{ position: "absolute", left: 178, top: -30, bottom: -32, width: 1, background: "#eaeeed", zIndex: 0 }}/>
      {timeline.map((entry, index) => (
          
        <div key={entry.id} style={{ display: "flex", alignItems: "center", gap: 30, position: "relative" }}>
          <div
              style={{
                background: "#E9F5EB",
                padding: "8px 12px",
                borderRadius: 12,
                minWidth: 140,
                display: "flex",
                gap: 8,
                alignItems: "center",
                fontWeight: "500",
                fontSize: "15px",
                color: "#183930",
              }}
            >
              <CalendarIcon />
              {entry.date}
            </div>
           
           {(() => {
    const label = getStatusLabel(entry.status);

    const style = statusStyles[label] || statusStyles["Investment"];
    const dot   = dotStyles[label]   || dotStyles["Investment"];

    return (
      <div
        style={{
          position: "absolute",
          left: 167,
          width: 22,
          height: 22,
          borderRadius: "50%",
          background: dot.outerBg,
          border: `1px solid ${dot.outerBorder}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2,
        }}
      >
        <div
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            background: dot.innerBg,
          }}
        />
      </div>
      );
    })()}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{
                duration: 0.4,
                delay: index * 0.2, 
              }}
              style={{
                flex: 1,
                marginLeft: 40, 
                border: "1px solid #eaeeed",
                borderRadius: 12,
                padding: 20,
                display: "flex",
                justifyContent: "flex-start",
                //gap: 180,
                alignItems: "center",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
              }}
            >
              {(() => {
              const label = getStatusLabel(entry.status);
              const dot = dotStyles[label];

              return (
                <div
                  style={{
                    width: 38,
                    height: 40,
                    borderRadius: 8,
                    background: dot.outerBg,
                    border: `1px solid ${dot.outerBorder}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                {(() => {
                  const title = entry.title?.toLowerCase() || "";

                  if (title.includes("investment")) {
                    return <GoBriefcase size={18} style={{ color: dot.innerBg }} />;
                  }

                  if (title.includes("purchase")) {
                    return <FaArrowTrendUp size={18} style={{ color: dot.innerBg }} />;
                  }

                  if (title.includes("sale")) {
                    return <FaArrowTrendDown size={18} style={{ color: dot.innerBg }} />;
                  }

                  return (
                    <span
                      style={{
                        fontSize: 25,
                        color: dot.innerBg,
                        lineHeight: 1,
                        marginTop: "-2px",
                      }}
                    >
                      +
                    </span>
                  );
                 })()}
                </div>
              );
            })()}
              <div style={{ width: 10 }} />
              <div style={{ width: "45%" }}>

                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  
                <span style={{ fontWeight: 600 }}>
                  {entry.title}
                </span>

                <span
                  style={{
                    color: "#B0C1BD",   
                    fontSize: 14,
                  }}
                >
                  •
                </span>

                <span
                  style={{
                    color: "#111",
                    fontSize: 14,
                    fontWeight: 400,
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                  }}
                >
                  {entry.tranch}
                </span>
              </div>
                <div style={{ color: "#4D6D64", fontSize: 14 }}>
                  Purchased{" "}
                  {entry.sharesFrom === null
                    ? entry.sharesTo.toLocaleString()
                    : (entry.sharesTo - entry.sharesFrom || 0 ).toLocaleString()}{" "}
                  shares for{" "}
                  <span style={{ fontWeight: 700}}>
                    ₹ {Number(entry.totalConsideration || 0).toLocaleString("en-IN")}
                  </span>{" "}
                  becomes {getStatusLabel(entry.status).toLowerCase()}
                </div>
              </div>

             <div style={{ width: "20%", textAlign: "left" }}>
                <div style={{ fontSize: 13, color: "#4D6D64", textAlign: "left" }}>
                  Shares
                </div>
                {entry.sharesFrom ? (
                  <div style={{ display: "flex", gap: 8 }}>
                    {entry.sharesFrom.toLocaleString()}
                    <ArrowRightIcon style={{ marginTop: 4 }}  />
                    <div style= {{ color: "#349F6F", fontSize: "16px", fontWeight: "700"}}>{entry.sharesTo.toLocaleString()}</div>
                  </div>
                ) : (
                  <b>{entry.sharesTo.toLocaleString()}</b>
                )}
              </div>

              
                 <div style={{ width: "15%", textAlign: "left" }}>
                  <div style={{ fontSize: 13, color: "#4D6D64", textAlign: "left" }}>
                    Ownership
                  </div>
                <b>{entry.ownership} %</b>
              </div>

             {(() => {
              const label = getStatusLabel(entry.status);
              return (
                <div
                  style={{
                    background: statusStyles[label]?.bg,
                    color: statusStyles[label]?.color,
                    border: `1px solid ${statusStyles[label]?.border}`,
                    padding: "3px 14px",
                    borderRadius: 20,
                    fontSize: 13,
                    fontWeight: 600,
                    textWrap: "nowrap",
                  }}
                >
                  {label}
                </div>
              );
            })()}
            <div
            onClick={() => !loadingId && handleOpen(entry)}
            style={{
              marginLeft: "auto",
              cursor: loadingId === entry.id ? "wait" : "pointer",
              display: "flex",
              alignItems: "center",
              opacity: loadingId === entry.id ? 0.4 : 1,
            }}
          >
            <RightArrow width={18} height={18} />
          </div>
            </motion.div>
          </div>
        ))}
       </div>
    </div>
     {openEntry && (
      <CreateInvestment2
        transactionID={openEntry.id}
        investmentID={openEntry.investmentID}
        tranch={openEntry.tranch}
        initialData={entryData}
        timelineData={timelineData?.timeline}
        onBack={handleBack}
      />
    )}
    </div>
  );
};

export default InvestmentTimeline;